import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "budget",
  "use": "budget-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 25 24\" id=\"budget\"><path stroke=\"#A4A4AD\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M12.5 1v22m5-18H10a3.5 3.5 0 1 0 0 7h5a3.5 3.5 0 1 1 0 7H6.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol